/**
 * Flattened animal catalog for vendor profile selection.
 * Derived from the public site's animal data.
 */
export const VENDOR_ANIMAL_CATALOG = [
  // Hands-On Encounters
  { id: 'lemur-encounter', name: '(2) Lovable Lemurs', category: 'Hands-On Encounters', sitePrice: 995, siteAdditionalHour: 497.5 },
  { id: 'exotic-birds', name: '(4) Exotic Birds', category: 'Hands-On Encounters', sitePrice: 1250, siteAdditionalHour: 625 },
  { id: 'capuchin-monkey', name: '(1) Capuchin Monkey', category: 'Hands-On Encounters', sitePrice: 1500, siteAdditionalHour: 750 },
  { id: 'full-interactive', name: '(7-8) Interactive Animals', category: 'Hands-On Encounters', sitePrice: 1450, siteAdditionalHour: 0 },

  // Big Cats
  { id: 'bengal-tiger', name: 'Bengal Tiger', category: 'Big Cats', sitePrice: 3500, siteAdditionalHour: 0 },
  { id: 'white-tiger', name: 'White Tiger', category: 'Big Cats', sitePrice: 3500, siteAdditionalHour: 0 },
  { id: 'male-lion', name: 'Male Lion', category: 'Big Cats', sitePrice: 3500, siteAdditionalHour: 0 },

  // Extraordinary Animals
  { id: 'giraffe', name: 'Giraffe', category: 'Extraordinary Animals', sitePrice: 9900, siteAdditionalHour: 0 },
  { id: 'zebra', name: 'Zebra', category: 'Extraordinary Animals', sitePrice: 3500, siteAdditionalHour: 0 },
  { id: 'giraffe-zebra-package', name: 'Giraffe + Zebra Package', category: 'Extraordinary Animals', sitePrice: 13500, siteAdditionalHour: 0 },
  { id: 'camel', name: 'Camel', category: 'Extraordinary Animals', sitePrice: 1800, siteAdditionalHour: 0 },
  { id: 'flamingo-display', name: 'Flamingos', category: 'Extraordinary Animals', sitePrice: 5000, siteAdditionalHour: 0 },
  { id: 'elephant', name: 'Adult Elephant', category: 'Extraordinary Animals', sitePrice: 16000, siteAdditionalHour: 0 },
  { id: 'brown-horse', name: 'Brown Horse', category: 'Extraordinary Animals', sitePrice: 1200, siteAdditionalHour: 0 },
  { id: 'white-horse', name: 'White Horse', category: 'Extraordinary Animals', sitePrice: 1800, siteAdditionalHour: 0 },
  { id: 'kangaroo-wallaby', name: 'Kangaroo / Wallaby', category: 'Extraordinary Animals', sitePrice: 3200, siteAdditionalHour: 0 },

  // Petting Zoo
  { id: 'luxury-petting-zoo', name: 'Luxury Petting Zoo', category: 'Petting Zoo', sitePrice: 1200, siteAdditionalHour: 0 },
  { id: 'pony-addon-1hr', name: 'Pony Rides (1 Hour)', category: 'Petting Zoo', sitePrice: 500, siteAdditionalHour: 0 },
  { id: 'pony-addon-2hr', name: 'Pony Rides (2 Hours)', category: 'Petting Zoo', sitePrice: 750, siteAdditionalHour: 0 },

  // Props & Decor
  { id: 'accent-lighting', name: 'Accent Lighting', category: 'Props & Decor', sitePrice: 600, siteAdditionalHour: 0 },
  { id: 'jungle-trees', name: 'Jungle Trees & Hanging Vines', category: 'Props & Decor', sitePrice: 600, siteAdditionalHour: 0 },
  { id: 'decorative-camel', name: "8' Decorative Dressed Camel", category: 'Props & Decor', sitePrice: 750, siteAdditionalHour: 0 },
  { id: 'leather-elephant', name: "Life-Size Leather Baby Elephant (6')", category: 'Props & Decor', sitePrice: 750, siteAdditionalHour: 0 },
  { id: 'safari-signage', name: 'Custom Safari Entrance Signage', category: 'Props & Decor', sitePrice: 995, siteAdditionalHour: 0 },
  { id: 'hedge-wall', name: 'Custom Hedge Wall Photo Backdrop', category: 'Props & Decor', sitePrice: 995, siteAdditionalHour: 0 },
  { id: 'custom-signage', name: 'Custom Signage & Printed Decor', category: 'Props & Decor', sitePrice: 500, siteAdditionalHour: 0 },
];

export const CATALOG_CATEGORIES = [...new Set(VENDOR_ANIMAL_CATALOG.map(a => a.category))];
